import {userIsInRoles} from './validate';
import history from './history';
import {concatUrl} from './url';


const get_user_data_url = concatUrl(window.ROOT_URL, 'api', 'get_user_data');


function _checkGetUserDataResponse(response) {
    if (response.ok) {
        return response.json();
    }
}

function _handleUserData(data, callback) {
    if(data && data.user){
        callback(data.user);
    }else{
        callback(null);
    }

    // Check version
    if(data && data.version){
        if(window.VERSION !== data.version){
            if(confirm('A new version of PCW was deployed on server side. Please reload the page in your browser to get the latest version.')){
                window.location.href = '/';
            }
        }
    }
}

function _getUserData(callback){
    fetch(
        get_user_data_url,
        {
            method: "GET",
            credentials: 'include',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        }
    ).
    then((response) => _checkGetUserDataResponse(response)).
    then((data) => _handleUserData(data, callback)).
    catch((error) => {
        console.warn(error + ' - ' + get_user_data_url);
    });
}

export function getUser(callback){
    // check if the user is logged in (has a valid session on the server) and return user data.
    _getUserData(callback);
}

export function redirectToLogin(){
    if(history.location.pathname !== '/login') {
        history.push("/login");
        document.location.reload();
    }
}

export function checkUserRoles(user, roles){
    // check if the user is member of roles.
    return !!userIsInRoles(user, roles);
}